import { render, staticRenderFns } from "./AccessRegistrationForm.vue?vue&type=template&id=2841eacc&scoped=true"
import script from "./AccessRegistrationForm.vue?vue&type=script&lang=js"
export * from "./AccessRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./AccessRegistrationForm.vue?vue&type=style&index=0&id=2841eacc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841eacc",
  null
  
)

export default component.exports